import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import { BoReference } from './bo-reference.js'
import { BusinessObject } from './business-object.js'
import {
	jsonArrayProperty,
	jsonClass,
	jsonProperty,
} from '@sumbricht/json-class-serializer'
import { ReportViewStatic } from './report-view-static.js'

@jsonClass('Report')
export class Report extends BusinessObject {
	@jsonProperty(BoReference)
	baseEntityRef!: BoReference
	@jsonProperty(BoReference)
	serverDataStoreRef!: BoReference
	@jsonArrayProperty(ReportViewStatic)
	staticViews: ReportViewStatic[] = []
	@jsonArrayProperty(String)
	fullDataProperties: string[] = []
	constructor(init?: Partial<Report>) {
		super()
		assignCommonProperties(this, init)
	}

	getClassNames(): string[] {
		return [this.getQualifiedName()]
	}
}
